<template>
  <div class="page">
    <b-row>
      <b-col cols="6" style="padding-top:2rem; ">
        Risk Assessment Type
      </b-col>
      <b-col>
        <img
          src="../../assets/AGBlackGCrop.png"
          style="height:200px; margin: none; padding: none;"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        Risk Assessor : Dave
      </b-col>
      <b-col>
        Arranged By : Davide
      </b-col>
    </b-row>
    <b-row>
      <b-col> Date : 18/05/2023 </b-col>
      <b-col> Time : 12:01 PM </b-col>
    </b-row>
    <b-row>
      <b-col> Room/Area : 5th </b-col>
      <b-col> Location Note : Ward 6 </b-col>
    </b-row>
    <b-row>
      <b-col cols="6"> Contact Name : Contact1 </b-col>
      <b-col cols="6"> Contact Email : Contact1@email.com </b-col>
    </b-row>
    <b-row>
      <b-col> Contact Note : Do the assessment </b-col>
    </b-row>
    <hr />
    <section class="avoid">
      <b-row>
        <b-col> <h4>Area</h4> </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 1 </b-col>
        <b-col cols="8"> A 1 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 2 </b-col>
        <b-col cols="8"> A 2 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 3 </b-col>
        <b-col cols="8"> A 3 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 4 </b-col>
        <b-col cols="8"> A 4 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 5 </b-col>
        <b-col cols="8"> A 5 </b-col>
      </b-row>
    </section>
    <hr />
    <section class="avoid">
      <b-row>
        <b-col> <h4>People</h4> </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 1 </b-col>
        <b-col cols="8"> A 1 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 2 </b-col>
        <b-col cols="8"> A 2 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 3 </b-col>
        <b-col cols="8"> A 3 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 4 </b-col>
        <b-col cols="8"> A 4 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 5 </b-col>
        <b-col cols="8"> A 5 </b-col>
      </b-row>
    </section>
    <hr />
    <section class="avoid">
      <b-row>
        <b-col> <h4>Outlets</h4> </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 1 </b-col>
        <b-col cols="8"> A 1 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 2 </b-col>
        <b-col cols="8"> A 2 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 3 </b-col>
        <b-col cols="8"> A 3 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 4 </b-col>
        <b-col cols="8"> A 4 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 5 </b-col>
        <b-col cols="8"> A 5 </b-col>
      </b-row>
    </section>
    <hr />
    <section class="avoid">
      <b-row>
        <b-col> <h4>Cold Water</h4> </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 1 </b-col>
        <b-col cols="8"> A 1 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 2 </b-col>
        <b-col cols="8"> A 2 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 3 </b-col>
        <b-col cols="8"> A 3 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 4 </b-col>
        <b-col cols="8"> A 4 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 5 </b-col>
        <b-col cols="8"> A 5 </b-col>
      </b-row>
    </section>
    <hr />
    <section class="avoid">
      <b-row>
        <b-col> <h4>Hot Water</h4> </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 1 </b-col>
        <b-col cols="8"> A 1 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 2 </b-col>
        <b-col cols="8"> A 2 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 3 </b-col>
        <b-col cols="8"> A 3 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 4 </b-col>
        <b-col cols="8"> A 4 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 5 </b-col>
        <b-col cols="8"> A 5 </b-col>
      </b-row>
    </section>
    <hr />
    <section class="avoid">
      <b-row>
        <b-col> <h4>Additional Factors</h4> </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 1 </b-col>
        <b-col cols="8"> A 1 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 2 </b-col>
        <b-col cols="8"> A 2 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 3 </b-col>
        <b-col cols="8"> A 3 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 4 </b-col>
        <b-col cols="8"> A 4 </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"> Q 5 </b-col>
        <b-col cols="8"> A 5 </b-col>
      </b-row>
    </section>
    <hr />
    <section class="avoid">
      <b-row>
        <b-col> <h4>Findings</h4> </b-col>
      </b-row>
      <b-row>
        <b-col>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus a
          sapien nec neque sodales tincidunt et ac massa. Sed finibus dolor ut
          maximus mattis. Fusce id venenatis massa, eu pretium lacus. Etiam
          elementum, quam ac luctus placerat, urna eros imperdiet dolor, sed
          tincidunt libero erat vel nisi. Etiam efficitur orci at orci bibendum,
          at blandit ante elementum. Duis ut placerat ipsum, ut pretium nibh.
          Praesent mattis ante ultricies sagittis molestie. Mauris convallis
          blandit enim, eget auctor mauris ornare sed. Phasellus ac eros
          efficitur, laoreet magna non, dictum metus. Cras at magna vitae nisl
          mollis laoreet. Orci varius natoque penatibus et.
        </b-col>
      </b-row>
    </section>
  </div>
</template>
<script>
// import axios from "axios";
import {} from "bootstrap-vue";

export default {
  components: {},
  computed: {
    htmlToPdfOptions() {
      return {
        margin: 2,
        filename: "",
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        pagebreak: { mode: "avoid-all", after: ".avoidThisRow" },
      };
    },
  },
  data() {
    return {};
  },
  mounted() {
    // if (this.ColonyDetails[0].chartAt(0) == "4") {
    // } else if (this.ColonyDetails[0].chartAt(0) == "5") {
    // }
  },
  methods: {
    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            );
          }
        })
        .save();
    },
    generateReport() {},
  },
};
</script>
<style>
.page {
  padding: 1rem;
  text-align: left;
  width: 100%;
}
.numberCol {
  border-bottom: 1px solid gray;
  /* margin-bottom: 1px;
  padding-bottom: 2px; */
}
.avoid {
  page-break-inside: avoid;
}
</style>
